// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__oC7oN","paramInput":"JobSimulator_paramInput__2ILBv","input":"JobSimulator_input___tmez"};